import React, { Fragment } from "react";
import "@redq/reuse-modal/es/index.css";
import "../customElements/css/home.css";
import "../customElements/css/dyesSubPages.css";
import CustomSection from "../customElements/components/section";
import DetailCard from "../customElements/components/detailsCard";
import styled from "styled-components";
import DetailsCard from "../customElements/components/detailsCard";
import Contactdetails from "../customElements/components/contactdetailscard";
import { Container } from "../customElements/components/yuvaContainer";
import Layout from "../customElements/components/layout.js";
import BannerSections from "../customElements/components/bannerSection";
import BannerImg from "../images/dyes/Feereimbursmentbanner.png";

class Feereimbursment extends React.Component {
    constructor() {
        super();
    
        this.state = {
          isKannada: true
        };
        this.toggleLang = this.toggleLang.bind(this);
      }
    
      toggleLang() {
        this.setState({ isKannada: !this.state.isKannada });
      }
    render( )
    {
        const P = styled.div`
        color: #666666;
        font-family: Lato;
        font-size: 16px;
        line-height: 31px;
        padding-bottom: 20px;
      `;
        return(
            <Layout title="Yuva | ನಗದು ಪುರಸ್ಕಾರ | CASH AWARD " isKannada={this.state.isKannada} toggleLang={this.toggleLang}>
            <BannerSections bgImg={BannerImg}
                title= {this.state.isKannada ? "ಶುಲ್ಕ ಮರು-ವಿತರಣೆ" : "Fee Re-imbursement"}>
            </BannerSections>
            <div className="section">
          <Container>
            <div className="w-100">
              <div className="m-0">
                {/* <OneDetailParent> */}
                <P>
                  {this.state.isKannada
                    ? "ಒಂದೇ ಸೂರಿನಡಿ ಯುವಕರಿಗೆ ಮಾಹಿತಿ, ಸ್ಫೂರ್ತಿ ಮತ್ತು ತರಬೇತಿಯನ್ನು ನೀಡಲು ಕರ್ನಾಟಕ ಸರ್ಕಾರವು ಮಾಡಿದ ಪ್ರಯತ್ನಗಳನ್ನು ಯುವ ಸಬಲಿಕರಣ ಕೇಂದ್ರಗಳ ರೂಪದಲ್ಲಿ ಸಾಕಾರಗೊಳಿಸಲಾಗಿದೆ. ಈ ಕೇಂದ್ರಗಳನ್ನು ಪ್ರತಿ ಜಿಲ್ಲೆಗೆ, ಎಲ್ಲಾ ಜಿಲ್ಲೆಗಳಲ್ಲಿ, ಆಯಾ ಲೀಡ್ ಸರ್ಕಾರಿ ಪ್ರಥಮ ದರ್ಜೆ ಕಾಲೇಜುಗಳಲ್ಲಿ ಸ್ಥಾಪಿಸಲಾಗಿದೆ. ಈ ಕೇಂದ್ರಗಳು ಉನ್ನತ ಶಿಕ್ಷಣದಲ್ಲಿ ವೃತ್ತಿ ಆಯ್ಕೆಗಳು ಮತ್ತು ಅವಕಾಶಗಳ ಬಗ್ಗೆ ಜಾಗೃತಿ ಮೂಡಿಸುವ ಗುರಿಯನ್ನು ಹೊಂದಿವೆ." : "The efforts of the Karnataka Government to provide information, inspiration and training to youth under a single roof is actualized in the form of Yuva Sabalikarana Kendras. These Kendras are established one per district, in all districts, at the respective Lead Government First Grade Colleges. These Kendras aim at creating awareness about career choices and Opportunities in Higher Education, in fields opted."}
                </P>
                 <DetailCard
                  detailtitle={
                    this.state.isKannada
                      ? "ಅರ್ಹತೆ"
                      : "Eligibility criteria for the scheme/Services"
                  }
                >
                  {this.state.isKannada ? (
                    <ul>
                      <li>
                      ಪ್ರಥಮ ಪಿಯುಸಿ ಯಿಂದ ಸ್ನಾತಕೋತ್ತರ ಪದವಿಯವರೆಗೆ ವ್ಯಾಸಂಗ ಮಾಡುತ್ತಿರುವ  ಕ್ರೀಡಾ ವಿದ್ಯಾರ್ಥಿಗಳಿಗೆ ಶುಲ್ಕ ಮರು ಭರಿಕೆ ಯೋಜನೆಗೆ ಅರ್ಹರಿರುತ್ತಾರೆ.
                      </li>
                      <li>
                      5ನೇ ತರಗತಿಯಿಂದ ಸ್ನಾತಕೋತ್ತರ ಪದವಿಯವರೆಗಿನ ಈಜು ಮತ್ತು ಜಿಮ್ನಾಸ್ಟಿಕ್‍ನಲ್ಲಿ ಭಾಗವಹಿಸಿರುವ ಕ್ರೀಡಾಳುಗಳು ಶುಲ್ಕ ಮರು ಭರಿಕೆ ಯೋಜನೆಗೆ ಅರ್ಹರಿರುತ್ತಾರೆ.
                      </li>
                      <li>
                      ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟದಿಂದ ಮಾನ್ಯತೆ ಪಡೆದಿರುವ ರಾಷ್ಟ್ರ ಮಟ್ಟದ ಸ್ಪರ್ಧೆಯಲ್ಲಿ ಭಾಗವಹಿಸಿ ಪದಕ ಪಡೆದಿರುವವರು.
                      </li>
                    </ul>
                  ) : (
                    <ul>
                      <li>
                        {" "}
                        Education Fee will be reimbursed for 1st PUC to Post Graduation.

                      </li>
                      <li>
                        {" "}
                        For sports persons who are in Swimming and Gymnastics disciplines will be eligible for fee reimbursement from 5th Std to Post Graduation.

                      </li>
                      <li>
                        {" "}
                        Sports persons who have won medals/ participated in national level competitions organised by recognized National Sports Federations
                      </li>
                    </ul>
                  )}
                </DetailCard>
                <div className="pb-5" />
                <DetailCard
                  detailtitle={
                    this.state.isKannada
                      ? "ಅಗತ್ಯವಾಗಿ ಬೇಕಾಗಿರುವ ದಾಖಲೆಗಳ"
                      : "Documents required"
                  }
                >
                  {this.state.isKannada ? (
                    <ul>
                      <li>ಅರ್ಹತಾ ಮಾನದಂಡದಲ್ಲಿ ಸಂಘಟಕರು ನೀಡಿರುವ ಪದಕ ಪ್ರಮಾಣಪತ್ರ / ಭಾಗವಹಿಸಿರುವ ಪ್ರಮಾಣ ಪತ್ರ.</li>
                     <li>  ರಾಷ್ಟ್ರಿಯ ಮಟ್ಟದ ಸ್ಪರ್ಧೆಗೆ ಆ0iÉ್ಕುಯಾಗಿರುವ ಬಗ್ಗೆ ರಾಜ್ಯ ಕ್ರೀಡ ಒಕ್ಕೂಟ ಮತ್ತು ಅಂತರಾಷ್ಟ್ರೀಯ ಸ್ಪರ್ಧೆಗಳಿಗೆ ಆ0iÉ್ಕುಯಾಗಿರುವ ಬಗ್ಗೆ ರಾಷ್ಟ್ರೀಯ ಕ್ರೀಡಾ ಒಕ್ಕೂಟ ನೀಡಿರುವ ಆ0iÉ್ಕು ಪ್ರಮಾಣ ಪತ್ರ.</li>
                    </ul>
                  ) : (
                    <ul>
                      <li> Medal Certificate/ Participation Certificate issued by the organisers as per the eligibility criteria.Caste and income certificate</li>
                      <li> Medal Certificate/ Participation Certificate issued by the organisers as per the eligibility criteria.</li>
                  </ul>
                  )}
                </DetailCard>
                <div className="pb-5" />
                <DetailCard
                  detailtitle={
                    this.state.isKannada
                      ? "ಉಸ್ತುವಾರಿ ಅಧಿಕಾರಿಗಳ ಇಮೇಲ್"
                      : "CONTACT DETAILS"
                  }
                >
                  <ul className="envolopIcon">
                    <li>dyesjdys@gmail.com</li>
                    <li>ddpykka@gmail.com</li>
                  </ul>
                </DetailCard>
                <div className="text-center mt-3 ">
                  <a href="https://karepass.cgg.gov.in/#!" target="newtab">
                    <button className="infoCtaRedbutton m-auto ">
                      <span>
                        {/* {this.state.isKannada ? "" : "Register now"}  */}
                        For more details visit : www.karepass.cgg.gov.in
                      </span>
                    </button>
                  </a>
                </div>
                {/* </OneDetailParent> */}
              </div>
            </div>
          </Container>
        </div>
            </Layout>

        )
    }
}

 export default Feereimbursment;